import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faExclamationCircle,
  faTimesCircle,
  faInfoCircle,
  faCheckCircle,
  faTimes,
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faCheck
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faTimes,
  faExclamationCircle,
  faTimesCircle,
  faInfoCircle,
  faCheckCircle,
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faCheck
);
